import { useQuery } from "react-query";
import { getLeasedEquipment } from "../../../../../actions/CarrierAgreementMgmt/LeasedEquipment";                                          

const useGetLeasedEquipmentReport  = (searchInputsData) => {
  // return useQuery(["GetBusLicensePermitReport",searchInputsData],() => getLeasedEquipment(searchInputsData),
  //   {
  //     refetchOnWindowFocus: false,      
  //   }
  // );
   
   return useQuery(["GetBusLicensePermitReport"],() => getLeasedEquipment(),
    {
      refetchOnWindowFocus: false,      
    }
  );
};
export default useGetLeasedEquipmentReport;
